import { connect } from 'react-redux';
import BrokerMaintenance from 'components/Broker/BrokerMaintenance/BrokerMaintenance';
import { getBrokerSettings, saveBrokerCorrespondent, saveBrokerCompanies } from 'actions/broker';

const mapStateToProps = (state) => {
  return {
    isFetchingSettings: state.brokerMaintenanceSettings.isFetchingSettings,
    isSubmittingSettings: state.brokerMaintenanceSettings.isSubmittingSettings,
    brokerSettings: state.brokerMaintenanceSettings.brokerSettings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getBrokerSettings() {
    dispatch(getBrokerSettings());
  },
  saveBrokerCorrespondent(request) {
    dispatch(saveBrokerCorrespondent(request));
  },
  saveBrokerCompanies(request) {
    dispatch(saveBrokerCompanies(request));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(BrokerMaintenance); 